import styled from 'styled-components/macro';
import { SM } from '@zendeskgarden/react-typography';
import Flex from 'styled-flex-component';

export const GalleryWrapper = styled.div`
  flex-shrink: 0;
`;

export const Thumbnail = styled.div`
  width: ${(props) => (props.large ? '70px' : '40px')};
  height: ${(props) => (props.large ? '70px' : '40px')};
  overflow: hidden;
  margin: 3px;
`;

export const Thumbnails = styled.div`
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  margin-top: 10px;
`;
export const AdditionalImageCountWrapper = styled.div`
  display: inline-block;
  width: 40px;
  vertical-align: top;
  margin-top: 9px;
`;

export const AdditionalImageCountFlexWrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
`;

export const AdditionalImageCount = styled(SM)``;

export const ImageViewOverlay = styled.div`
  position: relative;
  bottom: -40px;
  height: 35px;
  width: 150px;
  font-weight: 700;
  background-color: #000;
  opacity: 0.8;
  color: #fff;
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 2px;
  z-index: 2;
`;

export const ImageViewOverlayWrapper = styled(Flex)`
  width: 600px;
  @media (max-width: 2561px) {
    width: ${(props) => (props.isDashboard ? '100%' : '700px')};
  }
  @media (max-width: 1820px) {
    width: ${(props) => (props.isDashboard ? '175%' : '600px')};
  }
  @media (max-width: 1200px) {
    width: ${(props) => (props.isDashboard ? '120%' : null)};
  }
  @media (max-width: 500px) {
    display: none;
    width: 0px;
  }
`;

export const GalleryContainer = styled.div`
  display: flex;
  width: 100%;
  justify-content: center;
  flex-wrap: wrap;
  max-width: 600px;
  position: relative;
  overflow: hidden;
  margin-top: 20px;
`;

export const GalleryImage = styled.img`
  width: 100%;
  min-width: 300px;
  max-width: 100%;
  min-height: 600px;
  max-height: 100%;
  object-fit: contain;
  overflow: hidden;
  border-radius: ${props => props.rework ? '1%' : '0'};
`;

export const ThumbnailsContainer = styled.div`
  margin-top: 20px;
  display: flex;
  flex-wrap: wrap;
  width: 100%;
  max-width: 600px;
`;

export const ThumbnailItem = styled.div`
  min-width: 60px;
  width: 60px;
  height: 60px;
  cursor: pointer;
  overflow: hidden;
  border: 2px solid ${props => props.active ? '#0268ef' : 'transparent'};
  border-radius: ${props => props.rework ? '5%' : '0'};

  img {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }
`;

export const ThumbnailCounter = styled.div`
  min-width: 60px;
  width: 60px;
  height: 60px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #f5f5f5;
  border-radius: ${props => props.rework ? '5%' : '0'};
`;
